import { useOutletContext } from 'react-router-dom';
import { SalesInner } from './Sales';
import type { User } from '../api/types';

/** Wrapper that mounts the existing Sales body inside SalesLayout's Outlet. */
export default function SalesIndex() {
  const user = useOutletContext<User>();
  return <SalesInner user={user} embedded />;
}
